import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import CustomerAutocomplete from '../common/customerautocomplete';
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    FormControlLabel,
    Checkbox,
    useMediaQuery,
    Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const AddWarehouseDialog = ({ open, customers, addCb, cancelCb }) => {
    const [name, setName] = useState('');
    const [allowOrderTo, setAllowOrderTo] = useState(false);
    const [allowOrderFrom, setAllowOrderFrom] = useState(false);
    const [showCustomerAutocomplete, setShowCustomerAutocomplete] = useState(false);
    const [customer, setCustomer] = useState(null);

    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const selectCustomer = (id, cust) => {
        setCustomer(cust);
        setAllowOrderFrom(false);
        setAllowOrderTo(true);
    };

    const handleAdd = () => {
        addCb({ name, allowOrderFrom, allowOrderTo, customer });
    };

    const toggleCustomerSelector = () => {
        if (showCustomerAutocomplete) {
            setCustomer(null);
            setAllowOrderFrom(false);
            setAllowOrderTo(false);
        }
        setShowCustomerAutocomplete((s) => !s);
    };

    return (
        <Dialog
            onClose={() => {}}
            aria-labelledby="simple-dialog-title"
            open={open}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <DialogContent dividers>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <TextField
                        label={t('general.name')}
                        variant="standard"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <Tooltip title={t('warehouse.hintCanBeOrderedInto')}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    disabled={customer}
                                    checked={allowOrderTo}
                                    onChange={(e) => setAllowOrderTo(e.target.checked)}
                                />
                            }
                            label={t('warehouse.orderToWarehouse')}
                        />
                    </Tooltip>

                    <Tooltip title={t('warehouse.hintCanBeOrderedFrom')}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={allowOrderFrom}
                                    disabled={customer}
                                    onChange={(e) => setAllowOrderFrom(e.target.checked)}
                                />
                            }
                            label={t('warehouse.orderFromWarehouse')}
                        />
                    </Tooltip>

                    <div>
                        <Tooltip title={t('warehouse.hintLinkWarehouseToCustomer')}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={toggleCustomerSelector}
                                style={{ marginBottom: 8 }}>
                                {showCustomerAutocomplete ? t('warehouse.removeCustomer') : t('warehouse.addCustomer')}
                            </Button>
                        </Tooltip>

                        {showCustomerAutocomplete && (
                            <CustomerAutocomplete customers={customers} selected={selectCustomer} />
                        )}
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" disabled={!name || name.length < 3} onClick={handleAdd}>
                    {t('buttons.add')}
                </Button>
                <Button variant="contained" color="secondary" onClick={cancelCb}>
                    {t('buttons.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddWarehouseDialog;
